import { FeatureExplanationBlock } from '@models/feature-explanation';

import { UserExplanationSeparator } from './FeatureUserExplanationDisplay';

export function explanationToUserExplanation(
  tokens: FeatureExplanationBlock[]
): string {
  return explanationBlockToString(tokens).flat(Infinity).join('');
}

function explanationBlockToString(tokens: FeatureExplanationBlock[]): any {
  return tokens.map(block => {
    const textWrapper = ColorizeUserExplanation(block);

    if (FeatureExplanationBlock.isTextExplanationBlock(block)) {
      return textWrapper(block.text);
    } else if (FeatureExplanationBlock.isColumnExplanationBlock(block)) {
      return textWrapper(block.columnName);
    } else if (FeatureExplanationBlock.isDataSlotExplanationBlock(block)) {
      return textWrapper(block.dataSlotName);
    } else if (FeatureExplanationBlock.isPetExplanationBlock(block)) {
      return textWrapper(block.stringRepresentation);
    } else if (
      FeatureExplanationBlock.isTextWithDataSlotContextExplanationBlock(block)
    ) {
      return textWrapper(block.text);
    } else if (FeatureExplanationBlock.isTopicExplanationBlock(block)) {
      return textWrapper(block.name);
    } else if (FeatureExplanationBlock.isOperatorExplanationBlock(block)) {
      return explanationBlockToString(
        block.tokens.map(token => ({
          ...token,
          pathType: block.type,
        }))
      );
    } else {
      return '...';
    }
  });
}

function ColorizeUserExplanation(block: FeatureExplanationBlock) {
  const wrap = (text: string | undefined) =>
    `${UserExplanationSeparator}` + text + `${UserExplanationSeparator}`;

  return (text: string | undefined) => {
    if (block.type === FeatureExplanationBlock.Type.DataSlot) {
      return wrap(text);
    } else if (
      block.type === FeatureExplanationBlock.Type.Column ||
      block.type === FeatureExplanationBlock.Type.PredictionExecutionTime
    ) {
      const pathType = block.pathType as FeatureExplanationBlock.Type;
      if (
        [
          FeatureExplanationBlock.Type.Filter,
          FeatureExplanationBlock.Type.Reduce,
        ].includes(pathType)
      ) {
        return wrap(text);
      }
    }
    return text;
  };
}
